import { render } from "./PatientPage.vue?vue&type=template&id=0bebbf73"
import script from "./PatientPage.vue?vue&type=script&lang=js"
export * from "./PatientPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__